import "../../../src/components/VGrid/_grid.sass";
import { createSimpleFunctional } from '../../util/helpers';
export default createSimpleFunctional('spacer', 'div', 'v-spacer');
//# sourceMappingURL=VSpacer.js.map